// SPDX-License-Identifier: AGPL-3.0-or-later

import {DiscoveryGuildHeader} from '@app/features/app/components/layout/DiscoveryGuildHeader';
import styles from '@app/features/app/components/layout/GuildLayout.module.css';
import {GuildSidebar} from '@app/features/app/components/layout/GuildSidebar';
import {AppDiscoveryPage} from '@app/features/discovery/apps/AppDiscoveryPage';
import {DiscoveryPage} from '@app/features/discovery/discovery/DiscoveryPage';
import {DiscoverySidebar} from '@app/features/discovery/discovery/DiscoverySidebar';
import {ThemeDiscoveryPage} from '@app/features/discovery/themes/ThemeDiscoveryPage';
import Discovery from '@app/features/discovery/state/Discovery';
import MobileLayout from '@app/features/ui/state/MobileLayout';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

export const DiscoveryLayout = observer(function DiscoveryLayout() {
	const mobileLayout = MobileLayout;
	const currentSection = Discovery.currentSection;

	useEffect(() => {
		void Discovery.loadCategories();
		void Discovery.search({offset: 0});
		return () => {
			Discovery.reset();
		};
	}, []);

	const renderMainContent = () => {
		switch (currentSection) {
			case 'apps':
				return <AppDiscoveryPage key="apps" />;
			case 'themes':
				return <ThemeDiscoveryPage key="themes" />;
			case 'communities':
			default:
				return <DiscoveryPage key="communities" data-flx="app.discovery-layout.discovery-page" />;
		}
	};

	if (mobileLayout.enabled) {
		return renderMainContent();
	}
	return (
		<div className={styles.guildLayoutContainer} data-flx="app.discovery-layout.guild-layout-container">
			<div className={styles.guildLayoutContent} data-flx="app.discovery-layout.guild-layout-content">
				<GuildSidebar
					header={<DiscoveryGuildHeader data-flx="app.discovery-layout.discovery-guild-header" />}
					content={<DiscoverySidebar data-flx="app.discovery-layout.discovery-sidebar" />}
					data-flx="app.discovery-layout.guild-sidebar"
				/>
				<div className={styles.guildMainContent} data-flx="app.discovery-layout.guild-main-content">
					<div style={{display: currentSection === 'communities' ? 'contents' : 'none'}}>
						<DiscoveryPage data-flx="app.discovery-layout.discovery-page" />
					</div>
					{currentSection === 'apps' && <AppDiscoveryPage />}
					{currentSection === 'themes' && <ThemeDiscoveryPage />}
				</div>
			</div>
		</div>
	);
});
